var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { FileUploadSection } from "../../../../shared-library/components/fileupload/fileUploadSection";
import EdButton from "../../../../web/components/generic/edbutton/edButton";
import ErrorNotification, { ErrorDisplayType, } from "@frameworks/salesjourney/components/Generic/ErrorNotification";
import profileDI from "@frameworks/salesjourney/components/Features/Profile/di/serviceLocator";
import { base64toExcel } from "@frameworks/salesjourney/utils/genericMethods";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import Loader from "@frameworks/shared-library/components/Loader";
var UploadAttendance = function (props) {
    var _a = __read(useState(false), 2), sampleFileLoader = _a[0], setSampleFileLoader = _a[1];
    var _b = __read(useState(false), 2), absenteeFileLoader = _b[0], setAbsenteeFileLoader = _b[1];
    var _c = __read(useState(false), 2), fileLoader = _c[0], setFileLoader = _c[1];
    var _d = __read(useState(undefined), 2), absenteeFileId = _d[0], setAbsenteeFileId = _d[1];
    var _e = __read(useState(), 2), absenteeData = _e[0], setAbsenteeData = _e[1];
    var getAbsenteeData = function () {
        setAbsenteeFileLoader(true);
        profileDI.profile
            .getAbsenteeData({})
            .then(function (resp) {
            if ((resp === null || resp === void 0 ? void 0 : resp.length) > 0) {
                setAbsenteeData(resp);
            }
            setAbsenteeFileLoader(false);
        })
            .catch(function () {
            setAbsenteeFileLoader(false);
        });
    };
    var getAbsenteeFile = function (file, fileName) {
        setFileLoader(true);
        profileDI.profile
            .downloadAbsenteeFile({
            fileName: file,
        })
            .then(function (resp) {
            base64toExcel(resp === null || resp === void 0 ? void 0 : resp.data, fileName);
            setFileLoader(false);
        })
            .catch(function (error) {
            console.log("error", error);
            setFileLoader(false);
        });
    };
    var getSampleFile = function () {
        setSampleFileLoader(true);
        profileDI.profile
            .getAbsenteeSampleFile()
            .then(function (resp) {
            base64toExcel(resp === null || resp === void 0 ? void 0 : resp.file, resp === null || resp === void 0 ? void 0 : resp.filename);
            setSampleFileLoader(false);
        })
            .catch(function () {
            setSampleFileLoader(false);
        });
    };
    useEffect(function () {
        getAbsenteeData();
    }, []);
    return (React.createElement("div", { className: "".concat((props === null || props === void 0 ? void 0 : props.className) && (props === null || props === void 0 ? void 0 : props.className)) },
        React.createElement("div", { className: "upload-csv" },
            React.createElement(FileUploadSection
            // reset={()=>{}}
            , { 
                // reset={()=>{}}
                disableCross: false, fileType: ["csv"], onSubmit: function (e) {
                    var base64DataSplit = e === null || e === void 0 ? void 0 : e.base64Data.split(",");
                    props === null || props === void 0 ? void 0 : props.setUploadedFile(e);
                }, fileSizeInMB: "5MB", fileSize: 5242880, placeholder: React.createElement("span", { className: "DMSanN_16_400 txt_primaryGrey " },
                    "Drag & Drop Attendance CSV or",
                    " ",
                    React.createElement("u", { className: "txt-midnight-blue DMSans_16_500 cursor-pointer" }, "Browse")), showColouredIcon: true, uploadIcon: React.createElement("i", { className: "edel-icon-upload" },
                    React.createElement("span", { className: "path1" }),
                    React.createElement("span", { className: "path2" }),
                    React.createElement("span", { className: "path3" })) })),
        React.createElement("div", { className: "d-flex align-items-center justify-content-between file-details " },
            React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey" }, "Supported Formats: csv"),
            React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey" }, "Max Size 5Mb"),
            React.createElement("span", { className: "DMSansNormal_12_400 txt_primaryGrey" }, sampleFileLoader ? (React.createElement("div", { className: "spinner-box sale pt-1" },
                React.createElement(Spinner, { animation: "border", variant: "primary", size: "sm" }))) : (React.createElement(EdButton, { className: "download-template", btnTyp: "midnight-blue-underline", value: "Download CSV Template", onClick: function () {
                    getSampleFile();
                } })))),
        React.createElement("div", { className: "DMSanM_14_500 mb-2" }, "Recently Uploaded This Month"),
        React.createElement("div", { className: "download-section" }, absenteeFileLoader ? (React.createElement("div", { className: "absentee-loader" },
            React.createElement(Loader, null))) : absenteeData && (absenteeData === null || absenteeData === void 0 ? void 0 : absenteeData.length) > 0 ? (absenteeData === null || absenteeData === void 0 ? void 0 : absenteeData.map(function (obj, idx) {
            return (React.createElement("div", { className: "download-block", key: idx },
                React.createElement("span", { className: "DMSanN_14_400" }, obj === null || obj === void 0 ? void 0 :
                    obj.file_name,
                    "_",
                    moment(obj === null || obj === void 0 ? void 0 : obj.created).format("DD-MM-YYYY")),
                fileLoader && absenteeFileId == idx ? (React.createElement("div", { className: "spinner-box sale d-flex justify-content-center" },
                    React.createElement(Spinner, { animation: "border", variant: "primary", size: "sm" }))) : (React.createElement("span", { className: "cursor-pointer", onClick: function () {
                        setAbsenteeFileId(idx);
                        getAbsenteeFile(obj === null || obj === void 0 ? void 0 : obj.requestfile, obj === null || obj === void 0 ? void 0 : obj.file_name);
                    } },
                    React.createElement("i", { className: "edel-icon-download-coloured" },
                        React.createElement("span", { className: "path1" }),
                        React.createElement("span", { className: "path2" }))))));
        })) : (React.createElement(ErrorNotification, { isOpen: true, errMsg: "No Data Found", displayType: ErrorDisplayType.INSECTION })))));
};
export default UploadAttendance;
